import { render, staticRenderFns } from "./a-html.vue?vue&type=template&id=297a9d9a&"
import script from "./a-html.vue?vue&type=script&lang=js&"
export * from "./a-html.vue?vue&type=script&lang=js&"
import style0 from "./a-html.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports